import { Dispatch } from 'redux';

import { getAppointments } from './api/appointments';
import {
  getIntentFromAdvisoryBffById,
  getIntentFromIntentServiceById,
  getListOfIntents,
} from './api/intents';
import { Appointment } from './interfaces/Appointment';
import { Intent, IntentOld } from './interfaces/Intent';

export const INTENTS_SET_DATA = 'Intents/set';
export const INTENTS_SET_LOADING = 'Intents/loading';
export const INTENTS_SET_ACTIVE = 'Intents/active';
export const INTENTS_SET_LOADED = 'Intents/loaded';

export const setActiveIntent = (
  intent: Intent | null | undefined,
): {
  type: string;
  payload: {
    intent: Intent | null | undefined;
  };
} => ({
  type: INTENTS_SET_ACTIVE,
  payload: { intent },
});

export const setIntents = (
  intents: IntentOld[],
): {
  type: string;
  payload: {
    intents: IntentOld[];
  };
} => ({
  type: INTENTS_SET_DATA,
  payload: { intents },
});

const getIntentFromList = (intents: IntentOld[], wantedIntentId?: string): IntentOld | null => {
  if (intents.length === 0) {
    return null;
  }

  // if wantedIntentId is not specified return first intent as default
  if (!wantedIntentId) {
    return intents[0];
  }

  const result = intents.find(
    intent => wantedIntentId === intent.intentId || wantedIntentId === intent.intentServiceIntentId,
  );

  // if wantedIntentId is not present in loaded intents, return first intent as default
  if (!result) {
    return null;
  }

  return result;
};

export const loadingIntents = (
  loading: boolean,
): {
  type: string;
  payload: {
    loading: boolean;
  };
} => ({
  type: INTENTS_SET_LOADING,
  payload: { loading },
});

export const setLoadedIntents = (
  loaded: boolean,
): {
  type: string;
  payload: {
    loaded: boolean;
  };
} => ({
  type: INTENTS_SET_LOADED,
  payload: { loaded },
});

async function loadChangedIntent(activeIntent: Intent, dispatch: Dispatch): Promise<void> {
  const { intentId } = activeIntent;
  const appointments = await getAllAppointments(intentId);

  const activeIntentWithData = await getIntentFromIntentServiceById(intentId);
  dispatch(
    setActiveIntent({
      ...activeIntentWithData,
      appointments: {
        appointments,
      },
    }),
  );
}

// export const doIntentChange =
//   (activeIntent: Intent) =>
//   async (dispatch: Dispatch): Promise<null | void> => {
//     if (!activeIntent?.intentId) {
//       return null;
//     }
//
//     await loadChangedIntent(activeIntent, dispatch);
//   };

const getAllAppointments = async (intentId: string | undefined): Promise<Appointment[]> => {
  return getAppointments(intentId);
};

export const loadIntents =
  (
    callback: ((activeIntent: Intent | null) => void) | undefined,
    activeIntentId?: string,
    userId?: string,
  ) =>
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(loadingIntents(true));

    const intents = await getListOfIntents(userId);
    // only as customer, a list is present, as broker or employee, it is empty !
    const activeIntent =
      getIntentFromList(intents, activeIntentId) ??
      (await getIntentFromAdvisoryBffById(activeIntentId));

    if (activeIntent) {
      await loadChangedIntent(activeIntent, dispatch);
    }

    if (intents.length === 0 && activeIntent) {
      dispatch(setIntents([activeIntent]));
    } else {
      dispatch(setIntents(intents));
    }

    dispatch(setLoadedIntents(true));

    if (callback) {
      callback(activeIntent);
    }
  };
